import axios from 'axios';
import rawData from '../data/official_uavt_iskenderun.json';

const rawUrl = process.env.REACT_APP_API_URL || `${window.location.origin}`;
const baseUrl = rawUrl.endsWith('/api') ? rawUrl : `${rawUrl}/api`.replace(/\/\//g, '/').replace(':/', '://');

export const getNeighborhoodDevelopments = async (neighborhoodName = null) => {
  try {
    const url = neighborhoodName 
      ? `${baseUrl}/NeighborhoodDevelopment/All?neighborhoodName=${encodeURIComponent(neighborhoodName)}`
      : `${baseUrl}/NeighborhoodDevelopment/All`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const getNeighborhoodDevelopmentByGuid = async (guid) => {
  try {
    const response = await axios.post(`${baseUrl}/NeighborhoodDevelopment/GetByGuid`, { guid });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    }
    throw error;
  }
};

// --- İskenderun Yerel Adres & Resmi NVI/UAVT Sokak Servisi (Public) ---
export const getIskenderunNeighborhoods = async () => {
  return rawData.map(item => item.name).sort((a, b) => a.localeCompare(b, 'tr'));
};

export const getIskenderunStreets = async (neighborhoodName) => {
  if (!neighborhoodName) return [];

  const cleanSelected = neighborhoodName.replace(/ Mahallesi/i, '').toLowerCase().replace(/i̇/g, 'i').trim();
  const matchedObj = rawData.find(item => {
    const cleanItem = item.name.replace(/ Mahallesi/i, '').toLowerCase().replace(/i̇/g, 'i').trim();
    return cleanItem === cleanSelected || cleanItem.includes(cleanSelected) || cleanSelected.includes(cleanItem);
  });

  return matchedObj ? matchedObj.streets : [];
};








